import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

@Injectable()
export class EventbusChannelEffects {
    constructor(private actions$: Actions) {}
}
